import React from 'react';
import classNames from 'classnames/bind';
import styles from './QRCodeModal.module.scss';
import { Row, Col, Divider } from 'antd';
import { SVGS } from '~/assets/assetsPath';
import styled from 'styled-components';
import moment from 'moment';
import { saveAs } from 'file-saver';
const cx = classNames.bind(styles);

const QRModal = styled.div`
    .ant-divider-horizontal {
        margin: 10px 0px;
    }
`;

const QRCodeModal = ({ setIsShowQRCodeModal, item }) => {
    const handleDownloadQR = () => {
        saveAs(item.qr_code_image, `qr-code-booking-${moment().valueOf()}.png`);
    };

    return (
        <QRModal>
            <Row justify="center" className={cx('name_page')}>
                QR code check
            </Row>
            <Row justify="center" className={cx('bio')}>
                Scan the code to use the service!
            </Row>
            <Row justify="center">
                <img src={item.qr_code_image} alt="" className={cx('qr_img')} />
            </Row>
            {/* <Row justify="center" className={cx('qr_time')}>
                03:56:57
            </Row> */}
            <div justify="center" className={cx('info')}>
                <Row className={cx('item')}>
                    <Col xs={12} className={cx('label')}>
                        <Row>Schedule code:</Row>
                    </Col>
                    <Col xs={12} className={cx('content')}>
                        <Row justify="end"> #{item.booking_code}</Row>
                    </Col>
                </Row>
                <Divider />
                <Row className={cx('item')}>
                    <Col xs={8} className={cx('label')}>
                        <Row>Name:</Row>
                    </Col>
                    <Col xs={16} className={cx('content')}>
                        <Row justify="end">{item.name}</Row>
                    </Col>
                </Row>
                <Divider />
                <Row className={cx('item')}>
                    <Col xs={12} className={cx('label')}>
                        <Row>Phone number:</Row>
                    </Col>
                    <Col xs={12} className={cx('content')}>
                        <Row justify="end">{item.phone}</Row>
                    </Col>
                </Row>
                <Divider />
                {/* <Row className={cx('item')}>
                    <Col xs={8} className={cx('label')}>
                        <Row>Address:</Row>
                    </Col>
                    <Col xs={16} className={cx('content')}>
                        <Row justify="end">{item.address}</Row>
                    </Col>
                </Row>
                <Divider /> */}
                <Row className={cx('item')}>
                    <Col xs={12} className={cx('label')}>
                        <Row>Time:</Row>
                    </Col>
                    <Col xs={12} className={cx('content')}>
                        <Row justify="end">
                            {item.time_start
                                ? moment(new Date(parseInt(item.time_start))).format('HH:mm, DD/MM/YYYY')
                                : null}
                        </Row>
                    </Col>
                </Row>
                {/* <Divider />
                <Row className={cx('item')}>
                    <Col xs={12} className={cx('label')}>
                        <Row>Service staff:</Row>
                    </Col>
                    <Col xs={12} className={cx('content')}>
                        <Row justify="end">{item.staff?.name}</Row>
                    </Col>
                </Row> */}
            </div>

            <Row style={{ marginTop: '20px' }}>
                <div className={cx('btn_login')} onClick={() => setIsShowQRCodeModal(false)}>
                    Done
                </div>
            </Row>
            <Row justify="center">
                <div className={cx('download')} onClick={handleDownloadQR}>
                    Download the QR code to your device
                    <img src={SVGS.IconDownloadQR} alt="" />
                </div>
            </Row>
        </QRModal>
    );
};

export default QRCodeModal;
